<template>
  <div class="container">
    <v-suburb v-show="ifGetSuburb" @change="changeGetSuburb" @close="getSuburbClose()"></v-suburb>
    <v-suburb v-show="ifSuburb" @change="changeSuburb" @close="suburbClose()"></v-suburb>
    <div class="main" v-show="!(ifGetSuburb||ifSuburb)">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">提货安装服务</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>提货安装下单</h2>
            <div class="notice-box" v-show="ifHoliday()">
                <div class="notice-yellow">
                    {{holidayWord()}}
                </div>
            </div>
            <div v-show="nextStep">
                <div class="weui-cells__title">联系信息</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="data.username">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="data.userphone">
                        </div>
                    </div>
                </div>
                <div class="notice-yellow form">
                最后一步，请填写联系信息，我们客服收到后会尽快给您电话回访确认服务细节
                </div>
                <br>
            </div>
            <div v-show="!nextStep">
                <div class="weui-cells__title">服务日期</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label for="" class="weui-label">服务日期</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="date" v-model="data.service_date" :min="dateToday()" >
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">服务类型</div>
                <div class="weui-cells weui-cells_checkbox">
                    <label class="weui-cell weui-check__label" for="s10" >
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s10" value="1" v-model="data.service" >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>提货 + 安装</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s11" >
                        <div class="weui-cell__hd">
                            <input type="radio" class="weui-check" name="checkbox1" id="s11" value="2" v-model="data.service"  >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>只提货</p>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="s12">
                        <div class="weui-cell__hd">
                            <input type="radio" name="checkbox1" class="weui-check" id="s12" value="3" v-model="data.service"  >
                            <i class="weui-icon-checked"></i>
                        </div>
                        <div class="weui-cell__bd">
                            <p>只安装</p>
                        </div>
                    </label>
                </div>
                <div v-show="data.service">
                    <div class="weui-cells__title" v-show="data.service!=3">基本信息</div>
                    <div class="weui-cells weui-cells_form" v-show="data.service!=3">
                        <div class="weui-cell weui-cell_select weui-cell_select-after">
                            <div class="weui-cell__hd">
                                <label for="" class="weui-label">车型</label>
                            </div>
                            <div class="weui-cell__bd">
                                <select class="weui-select" name="select2" v-model="data.vehicle" >
                                    <option value="" selected disabled>点击选择</option>
                                    <option value="1" >面包车</option>
                                    <option value="2" >小厢货</option>
                                    <option value="3" >大厢货</option>
                                </select>
                            </div>
                        </div>
                        <div class="weui-cell">
                            <div class="weui-cell__bd">
                                <textarea class="weui-textarea" placeholder="请填写详细的提货清单，好让我们做好准备" rows="3" v-model="data.detail"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="weui-cells__title" v-show="data.service!=3">提货信息</div>
                    <div class="weui-cells weui-cells_form" v-show="data.service!=3">
                        <div class="weui-cell">
                            <div class="weui-cell__hd"><label for="" class="weui-label" >提货时间</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="time" v-model="data.get_time" >
                            </div>
                        </div>
                        <div class="weui-cell" v-show="data.get_time">
                            <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" placeholder="提货地址 Street" v-model="data.get_street">
                            </div>
                        </div>
                        <div class="weui-cell weui-cell_access padding-fix"  @click="getSuburbSelect()" v-show="data.get_time">
                            <div class="weui-cell__hd">
                                <label class="weui-label">Suburb</label>
                            </div>
                            <div class="weui-cell__bd" v-if="data.get_suburb==''"> 
                                <p class="placeholder-color">提货地址 Suburb</p>
                            </div>
                            <div class="weui-cell__bd" v-if="data.get_suburb!=''"> 
                                <p>{{data.get_suburb}}</p>
                            </div>
                            <div class="weui-cell__ft"></div>
                        </div>
                        <div class="weui-cell weui-cell_select weui-cell_select-after" v-show="data.get_time">
                            <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                            <div class="weui-cell__bd">
                                <select class="weui-select" name="select2" >
                                    <option value="NSW" selected>NSW</option>
                                </select>
                            </div>
                        </div>
                        <div class="weui-cell" v-show="data.get_time">
                            <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" v-model="data.get_postcode" placeholder="提货地址 Postcode">
                            </div>
                        </div>
                    </div>
                    <div class="weui-cells__title" v-show="data.service!=3">送货信息</div>
                    <div class="weui-cells__title" v-show="data.service==3">上门安装信息</div>
                    <div class="weui-cells weui-cells_form" >
                        <div class="weui-cell">
                            <div class="weui-cell__hd"><label for="" class="weui-label" v-show="data.service!=3">送货时间</label></div>
                            <div class="weui-cell__hd"><label for="" class="weui-label" v-show="data.service==3">安装时间</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="time"  v-model="data.service_time"  >
                            </div>
                        </div>
                        <div class="weui-cell" v-show="data.service_time">
                            <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" placeholder="送货地址 Street" v-model="data.service_street" v-show="data.service!=3">
                                <input class="weui-input" type="text" placeholder="上门安装地址 Street" v-model="data.service_street" v-show="data.service==3">
                            </div>
                        </div>
                        <div class="weui-cell weui-cell_access padding-fix"  @click="suburbSelect()" v-show="data.service_time">
                            <div class="weui-cell__hd">
                                <label class="weui-label">Suburb</label>
                            </div>
                            <div class="weui-cell__bd" v-if="data.service_suburb==''"> 
                                <p class="placeholder-color" v-show="data.service!=3">送货地址 Suburb</p>
                                <p class="placeholder-color" v-show="data.service==3">上门安装地址 Suburb</p>
                            </div>
                            <div class="weui-cell__bd" v-if="data.service_suburb!=''"> 
                                <p>{{data.service_suburb}}</p>
                            </div>
                            <div class="weui-cell__ft"></div>
                        </div>
                        <div class="weui-cell weui-cell_select weui-cell_select-after" v-show="data.service_time">
                            <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                            <div class="weui-cell__bd">
                                <select class="weui-select" name="select2" >
                                    <option value="NSW" selected>NSW</option>
                                </select>
                            </div>
                        </div>
                        <div class="weui-cell" v-show="data.service_time">
                            <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                            <div class="weui-cell__bd">
                                <input class="weui-input" type="text" v-model="data.service_postcode" placeholder="送货地址 Postcode" v-show="data.service!=3">
                                <input class="weui-input" type="text" v-model="data.service_postcode" placeholder="送货地址 Postcode" v-show="data.service==3">
                            </div>
                        </div>
                    </div>
                    <div class="weui-cells__title" v-show="data.service!=2">安装信息</div>
                    <div class="weui-cells weui-cells_form"  v-show="data.service!=2">
                        <div class="weui-cell">
                            <div class="weui-cell__bd">
                                <textarea class="weui-textarea" placeholder="请填写货物的安装信息，我们将带上最合适的工具" rows="3" v-model="data.install_detail"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="weui-cells__title">留言备注</div>
                    <div class="weui-cells weui-cells_form">
                        <div class="weui-cell">
                            <div class="weui-cell__bd">
                                <textarea class="weui-textarea" placeholder="告诉我们更多需求，我们将给您提供更周到的服务" rows="3" v-model="data.message"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
            </div>
        </div>
        <div class="btn-box-fix">
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">立即下单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交订单</p>
            </div>
        </div>
    </transition>
    <img :src="pixelURL('TiHuoAnZhuang','xiadan')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
        data:{
            token:0,
            type_id:1550735968,
            username:"",
            userphone:"",
            service:"",
            service_date:"",
            service_time:"",
            service_street:"",
            service_suburb:"",
            service_state:"nsw",
            service_postcode:"",
            get_time:"",
            get_street:"",
            get_suburb:"",
            get_state:"nsw",
            get_postcode:"",
            install_detail:"",
            detail:"",
            vehicle:"",
            message:"",
        },
        ifGetSuburb:false,
        isSending:false,
        nextStep:false,
        ifSuburb:false,
        localError:[],
        localErrorShow:false,
        rememberTop:0
    }
  },
  methods: {
    goBack: function() {
        if(this.nextStep){
            this.nextStep = false;
            return false;
        }
        if(this.$route.query.back){
            this.$router.go(-1);
        }
        else{
            this.$router.push('/');
        }
    },
    dateToday: function(){
        let today = new Date().toISOString().slice(0, 10);
        return today;
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    //get_suburb 函数
    getSuburbSelect: function() {
        this.rememberGetTop = window.scrollY;
        this.ifGetSuburb=true;
        document.querySelector("html").classList.remove("service-convey-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    changeGetSuburb: function(suburb,postcode) {
        this.data.get_suburb = suburb;
        this.data.get_postcode = postcode.toString();
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberGetTop;
            document.body.scrollTop = this.rememberGetTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-convey-bg");
        this.ifGetSuburb=false;

    },
    getSuburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberGetTop;
            document.body.scrollTop = this.rememberGetTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-convey-bg");
        this.ifGetSuburb=false;
    },
    //service_suburb 函数
    suburbSelect: function() {
        this.rememberTop = window.scrollY;
        this.ifSuburb=true;
        document.querySelector("html").classList.remove("service-convey-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    changeSuburb: function(suburb,postcode) {
        this.data.service_suburb = suburb;
        this.data.service_postcode = postcode;
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-convey-bg");
        this.ifSuburb=false;

    },
    suburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-convey-bg");
        this.ifSuburb=false;
    },
    submitOrder: function() {
        if(!this.nextStep){
            if(this.checkSubmit()){
                this.nextStep=true;
                return false;
            }
        }
        if(this.nextStep){
            if(this.checkSubmitPost()){
                this.submitOrderPost();
            }
        }
    },
    checkSubmit(){
        this.localError = [];

        if (!this.data.service_date) {
            this.localError.push("请填写想预定的服务日期");
        }
        if (!this.data.service) {
            this.localError.push("请选择服务类型（ 提货 / 安装 ）");
        }
        if(this.data.service==1 || this.data.service==2){
            if (!this.data.vehicle) {
                this.localError.push("请选择服务车型");
            }
            if (!this.data.detail) {
                this.localError.push("请填写详细的提货清单");
            }
            if (!this.data.get_time) {
                this.localError.push("请填写提货时间");
            }
            if (!this.data.get_street) {
                this.localError.push("请填写提货地址 Street 信息");
            } else if (this.data.get_street.length < 5) {
                this.localError.push("提货地址 Street 长度过短，请检查是否正确");
            }
            if (!this.data.get_suburb) {
                this.localError.push("请选择提货地址 Suburb 信息");
            }
            if (!this.data.get_postcode) {
                this.localError.push("请填写提货地址 Postcode 邮编");
            } else if (this.data.get_postcode.length != 4) {
                this.localError.push("请填写4位数字提货地址 Postcode 邮编号码");
            }
            if (!this.data.service_time) {
                this.localError.push("请填写送货时间");
            }
            if (!this.data.service_street) {
                this.localError.push("请填写送货地址 Street 信息");
            } else if (this.data.service_street.length < 5) {
                this.localError.push("送货地址 Street 长度过短，请检查是否正确");
            }
            if (!this.data.service_suburb) {
                this.localError.push("请填写送货地址 Suburb");
            }
            if (!this.data.service_postcode) {
                this.localError.push("请填写提货地址 Postcode 邮编");
            } else if (this.data.service_postcode.length != 4) {
                this.localError.push("请填写4位数字送货地址 Postcode 邮编号码");
            }
        }


        if(this.data.service==3){
            if (!this.data.service_time) {
                this.localError.push("请填写安装时间");
            }
            if (!this.data.service_street) {
                this.localError.push("请填写安装地址 Street 信息");
            } else if (this.data.service_street.length < 5) {
                this.localError.push("安装地址 Street 长度过短，请检查是否正确");
            }
            if (!this.data.service_suburb) {
                this.localError.push("请填写安装地址 Suburb");
            }
            if (!this.data.service_postcode) {
                this.localError.push("请填写提货地址 Postcode 邮编");
            } else if (this.data.service_postcode.length != 4) {
                this.localError.push("请填写4位数字安装地址 Postcode 邮编号码");
            }
        }

        if(this.data.service==1 || this.data.service==3){
            if (!this.data.install_detail) {
                this.localError.push("请填写货物安装信息说明");
            }
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    checkSubmitPost(){
      this.localError = [];
      if (!this.data.username) {
          this.localError.push("请填写联系人名");
      }
      if (!this.data.userphone) {
          this.localError.push("请填写联系人手机号");
      }
      if (this.data.userphone.length<8 || this.data.userphone.length>11) {
          this.localError.push("手机号码长度不正确，请检查是否正确");
      }
      if (!this.localError.length) {
        return true;
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
        }
        else{
            orderObject.token = 0;
        }
        
        this.axios.post(this.apiURL()+'/Order/createTempOrder', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.$router.push('/order-form-success?id='+response.data.data.order_id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-convey-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-convey-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

</style>



// WEBPACK FOOTER //
// src/pages/service/form/convey.vue